var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPrivateMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54596 0.84375L25.0013 25.7285L25.1184 25.6369L25.6643 26.3353L24.1986 27.4812L21.1904 23.6335H15.9763V27.3779H13.6709V23.6335H7.14292H6.40341H4V13.1886H6.30536V21.1208H19.2259L16.4883 17.6193H9.60986V8.82127L4.19727 1.89818L5.54596 0.84375ZM9.60986 3.02096L19.5827 15.7769V1.41346H9.60986V3.02096ZM23.5102 20.8005L25.7251 23.6335H25.8156V13.1886H23.5102V20.8005Z",
    fill: "#8A939E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrivateMicOff);
export default __webpack_public_path__ + "static/media/ic_private_mic_off.1758d2cb033c14c505e5669469556501.svg";
export { ForwardRef as ReactComponent };